<template>
  <div class="search-filter-menu-loading d-none d-md-block">
    <div class="search-filter-menu-loading-input-row">
      <div class="search-filter-menu-loading-input" />
      <div class="search-filter-menu-loading-input" />
      <div class="search-filter-menu-loading-input" />
    </div>
    <div class="search-filter-menu-loading-filter-row">
      <div class="search-filter-menu-loading-filter" />
      <div class="search-filter-menu-loading-filter" />
      <div class="search-filter-menu-loading-filter" />
      <div class="search-filter-menu-loading-filter" />
      <div class="search-filter-menu-loading-filter" />
      <div class="search-filter-menu-loading-filter" />
      <div class="search-filter-menu-loading-filter" />
    </div>
  </div>
</template>

<script>
/*

@@author        j0Shi
@@date          2019.11.14
@@desc          ObjectSearchList placeholder that shows when object page loads
@@usedby        Search -> SearchObjectList

*/
export default {

};
</script>

<style lang="scss" scoped>
.search-filter-menu-loading-input-row {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: 20px;
}

.search-filter-menu-loading-filter-row {
  display: flex;
}

.search-filter-menu-loading-input {
  width: 48%;
  margin-top: 1rem;

  &:first-child {
    width: 100%;
    margin-top: 0;
  }

  @media #{$media_lg_min} {
    width: 31%;
    margin-top: 0;

    &:first-child {
      width: 31%;
    }
  }

  height: $placeholder-input-height;
  background-color: $placeholder-color1;
}

.search-filter-menu-loading {
  padding: 13px $margin_content;
}

.search-filter-menu-loading-filter {
  width: 115px;
  height: $placeholder-button-height;
  background-color: $placeholder-color1;
  margin: 0 0.5em 0.5em 0;

  @include radius(3em);
}
</style>
